// @flow
import getFeaturesForUser from '../api/getFeaturesForUser';
import { setFeatures } from './setFeatures';

export const loadFeaturesForUser = () => async (
    dispatch: Function,
    getState: any
) => {
    const userId = getState().app.loggedInUser.id;
    const response = await getFeaturesForUser(userId);
    dispatch(setFeatures(response.features));
};



// WEBPACK FOOTER //
// ./src/v5/features/state/loadFeaturesForUser.js